import { container } from '../../../DataDomain';
import { IAmazonActivateResponse } from '../../../entity';
import { ISlpRepository } from '../../repositories/interfaces/iSlpRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IAmazonActivateUseCase {
    execute(entitlementId: string): Promise<IAmazonActivateResponse>;
}

export class AmazonActivateUseCase implements IAmazonActivateUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get slpRepo(): ISlpRepository {
        return container.resolve<ISlpRepository>(DI.REPOSITORIES.ISlpRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(entitlementId: string): Promise<IAmazonActivateResponse> {
        return await this.slpRepo.amazonActivate(entitlementId);
    }
}
